import { render, staticRenderFns } from "./UnitSetting.vue?vue&type=template&id=b181bdcc&scoped=true&"
import script from "./UnitSetting.vue?vue&type=script&lang=js&"
export * from "./UnitSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b181bdcc",
  null
  
)

export default component.exports